import VeeValidate from '~/plugins/vee-validate'

export default {
  created () {
    VeeValidate({ store: this.$store })
  }
}
